module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('page-bar', {
    attrs: {
      "languages": true
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\n\t\tHome "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Seja bem vindo(a) ao portal administrativo")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group m-b-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userId),
      expression: "userId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "userId"
    },
    domProps: {
      "value": (_vm.userId)
    },
    on: {
      "change": _vm.updateUserId,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userId = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 blue",
    attrs: {
      "to": "/agenda"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-address-book-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Agenda")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 green-jungle",
    attrs: {
      "to": "/inbox"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-inbox",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Caixa de Mensagem")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 purple",
    attrs: {
      "to": "/get-at-school"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Monitor de Saída")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 yellow-casablanca",
    attrs: {
      "to": "/meal-menu"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-cutlery",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Cadastro de Cardápio")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 green",
    attrs: {
      "to": "/medicine"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-medkit",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Medicações")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 red-mint",
    attrs: {
      "to": "/gallery"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-camera",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Galeria de Fotos")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 green-haze",
    attrs: {
      "to": "/evaluation"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Indicadores")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 purple-medium",
    attrs: {
      "to": "/lesson-planning"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-file-text",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Plano de aula")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 purple-medium",
    attrs: {
      "to": "/lesson-planning/report"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-file-text",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Relatório Plano de aula")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/simulator"
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Simulador site")])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\t\t#\n\t\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baf2a526","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/dashboard/main.vue
// module id = 1103
// module chunks = 1